import React, { FC } from 'react'
import { Redirect, Route, Switch } from 'react-router'

import { routes } from '../../../constants/routes'
import { Assets } from './Assets'

export const SettingsAssetsRoutes: FC = () => (
  <Switch>
    <Route path={routes.SETTINGS_ASSETS_TABS} component={Assets} />
    <Redirect to={routes.SETTINGS_ASSETS} />
  </Switch>
)
